<template>
  <component :is="component" v-if="component" />
</template>

<script>
import gsk from '@/views/booths/gsk.vue';
import pfizer from '@/views/booths/pfizer.vue';
import alexion from '@/views/booths/alexion.vue';
import lilly from '@/views/booths/lilly.vue';
import farmanova from '@/views/booths/farmanova.vue';
import menarini from '@/views/booths/menarini.vue';
import msd from '@/views/booths/msd.vue';
import ucb from '@/views/booths/ucb.vue';

export default {
  data() {
    return {
      component: null,
    };
  },
  components: {
    gsk,
    pfizer,
    lilly,
    farmanova,
    menarini,
    ucb,
    msd,
    alexion,
  },
  computed: {},
  mounted() {
    this.component = this.$options.components[this.$route.params.id];
  },
};
</script>

<style>
</style>
